import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SectionEyebrow: FunctionComponent<Props> = ({
    className = '',
    eyebrowText,
    testId = TEST_ID,
    titleText
}) => (
    <VerticalContainer className={`${styles.sectionEyebrow} ${className}`} testId={testId}>
        <Wrapper className={styles.eyebrow}>{eyebrowText}</Wrapper>

        <Wrapper className={styles.title}>{titleText}</Wrapper>
    </VerticalContainer>
);

export default SectionEyebrow;
